export const splitValidationText = (text: string) => {
  return text
    .split(/\.\s+|(?=\([1-9]\))/)
    .flatMap((segment) => {
      const colonIndex = segment.indexOf(':');
      return colonIndex === -1
        ? [segment]
        : [segment.slice(0, colonIndex), segment.slice(colonIndex + 1).trim()];
    })
    .filter((msg: string) => msg.length > 1);
};
